let today = new Date();
let initialState = {
  backgroundColor: "#000",
  lat: 48.85661400000001,
  lng: 2.3522219000000177,
  title: "STARMAPPED",
  locationText: "Paris, France",
  message: "",
  timeDate: new Date(),
  showTime: false,
  showGrid: true,
  showConstellations: true,
  image: null,
  printSize: 2,
  location: window.location.pathname,
  nonUS: window.location.pathname !== "/" ? true : false,
  frameAdded: false,
  theme: 1,
  showEmailModal: false,
  cartLoading: false,
  day: today.getDate(),
  month: today.getMonth(),
  year: today.getYear(),
  file: null,
  printCost: 0,
  frameCost: 0,
  scale: 3,
  frame: 65,
  products: []
};

if (window.localStorage.getItem("print")) {
  initialState = {
    ...initialState,
    ...JSON.parse(window.localStorage.getItem("print"))
  };
  initialState.nonUS = window.location.pathname !== "/" ? true : false;
  initialState.timeDate = new Date(initialState.timeDate);
  initialState.cartLoading = false;
  initialState.showEmailModal = false;
  initialState.file = null;
  initialState.frameAdded = false;
  initialState.frameCost = 0;
  initialState.scale = 3;
}

export default function(state = initialState, action) {
  console.log(state);
  switch (action.type) {
    case "SET_CANVAS":
      window.localStorage.setItem(
        "print",
        JSON.stringify({
          ...state,
          ...action.payload
        })
      );
      return {
        ...state,
        ...action.payload
      };
      break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/CanvasReducer.js